<app-table
    [translatePrefix]="prefix"
    [showColumnVisiblity]="true"
    [columns]="columns()"
    [items]="items()"
    (detailCallback)="detail($event)"
    [showDetail]="showDetail() && !disabled()"
    [hideCheckboxes]="true"
    selectionMode="single"
    [tableKey]="tableKey()"
>

    <ng-template pTemplate="folder" let-data="data">
        <app-user-chip
            [user]="data.person"
            [renderType]="UserChipRenderTypeEnum.Client"
            [renderDetails]="false"
        ></app-user-chip>
    </ng-template>

    <ng-template pTemplate="code" let-item="item">
        @if (store.offerData()[item.offerId]?.code) {
            <app-chip
                [label]="store.offerData()[item.offerId].code"
                [color]="store.offerData()[item.offerId]?.color"
            ></app-chip>
        }
    </ng-template>

    <ng-template pTemplate="name" let-item="item">
        <app-strip-and-show
            [text]="store.offerData()[item.offerId]?.name || ''"
            [length]="50"
        ></app-strip-and-show>
    </ng-template>

    <ng-template pTemplate="unit" let-item="item">
        @if (store.offerData()[item.offerId]?.unit) {
            {{ 'enum.measurementUnit.' + store.offerData()[item.offerId]?.unit | translate }}
        }
    </ng-template>

    <ng-template pTemplate="applications" let-item="item">
        <app-number-input
            #applicationsInput
            [showLabel]="false"
            [attributes]="{
                offerId: item.offerId,
                folderId: item.folder?.id || folder()?.id || 0,
            }"
            (selectedValueChange)="setValue($event, 'applications', item.offerId, item)"
            [max]="maxApplication()"
            [min]="0"
            [disabled]="disabled()"
            [emitEnableChange]="false"
        ></app-number-input>
    </ng-template>

    <ng-template pTemplate="durationOther" let-item="item">
        <app-number-input
            #durationOtherInput
            [showLabel]="false"
            [attributes]="{
                offerId: item.offerId,
                folderId: item.folder?.id || folder()?.id || 0,
            }"
            (selectedValueChange)="setValue($event, 'durationOther', item.offerId)"
            [min]="0"
            [disabled]="disabled()"
            [emitEnableChange]="false"
        ></app-number-input>
    </ng-template>

    <ng-template pTemplate="areas" let-item="item">
        <app-multi-select-input
            #selectAreas
            [attributes]="{
                offerId: item.offerId,
                folderId: item.folder?.id || folder()?.id || 0,
            }"
            id="areas"
            [staticOptions]="store.data.getServiceSocialAreas()?.items || []"
            labelKey="name"
            valueKey="id"
            [showLabel]="false"
            [showClear]="true"
            [disabled]="disabled()"
            [emitEnableChange]="false"
            (selectedValueChange)="setValue($event, 'areas', item.offerId)"
        ></app-multi-select-input>
    </ng-template>

    <ng-template pTemplate="users" let-item="item">
        <div style="min-width: 150px">
            <app-input-user-multiselect
                #selectUserComponent
                [attributes]="{
                    offerId: item.offerId,
                    folderId: item.folder?.id || folder()?.id || 0,
                }"
                [serviceId]="serviceId()"
                [employment]="employments"
                [disabled]="disabled()"
                [emitEnableChange]="false"
                (selectedValueChange)="setValue($event, 'users', item.offerId, item)"
            ></app-input-user-multiselect>
        </div>
    </ng-template>

    <ng-template pTemplate="tags" let-item="item">
        <app-tags-input
            #selectTags
            [attributes]="{
                offerId: item.offerId,
                folderId: item.folder?.id || folder()?.id || 0,
            }"
            [suggestions]="store.data.searchWorkOfferTags()"
            (queryEvent)="queryTags($event)"
            [showLabel]="false"
            [showClear]="true"
            [disabled]="disabled()"
            [emitEnableChange]="false"
            (selectedValueChange)="setValue($event, 'tags', item.offerId)"
        ></app-tags-input>
    </ng-template>

    <ng-template pTemplate="note" let-item="item">
        <app-button
            [text]="true"
            [label]="(item.note?.length ? item.note : 'Zápis') | stripAndTrim:20"
            [disabled]="disabled()"
            (clickEvent)="noteDetail(item)"
        ></app-button>
    </ng-template>

    <ng-template pTemplate="type" let-item="item">
        <app-select-input
            #selectType
            [attributes]="{
                offerId: item.offerId,
                folderId: item.folder?.id || folder()?.id || 0,
            }"
            [showLabel]="false"
            [disabled]="disabled()"
            [emitEnableChange]="false"
            [staticOptions]="store.typeOptions()"
            (selectedValueChange)="setValue($event, 'type', item.offerId)"
        ></app-select-input>
    </ng-template>

    <ng-template pTemplate="presence" let-item="item">
        <app-select-input
            #selectPresence
            [attributes]="{
                offerId: item.offerId,
                folderId: item.folder?.id || folder()?.id || 0,
            }"
            [showLabel]="false"
            [disabled]="disabled()"
            [emitEnableChange]="false"
            [staticOptions]="store.presenceOptions()"
            (selectedValueChange)="setValue($event, 'presence', item.offerId)"
        ></app-select-input>
    </ng-template>
    <ng-template
        pTemplate="payByCredits"
        let-item="item"
    >
        @if (creditSelections()[creditSelectionKey(item)] !== undefined) {
            <app-check-input
                [formField]="creditFields[creditSelectionKey(item)]"
                label=""
                (valueChange)="setValue($event, 'payByCredits', item.offerId, item)"
            />
        }
    </ng-template>
</app-table>
